import { render, staticRenderFns } from "./DepartmentManager.vue?vue&type=template&id=18a81c41&scoped=true"
import script from "./DepartmentManager.vue?vue&type=script&lang=js"
export * from "./DepartmentManager.vue?vue&type=script&lang=js"
import style0 from "./DepartmentManager.vue?vue&type=style&index=0&id=18a81c41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a81c41",
  null
  
)

export default component.exports